// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CommentsController from "./comments_controller"
application.register("comments", CommentsController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TagsController from "./tags_controller"
application.register("tags", TagsController)
